<script setup>
import { inject } from 'vue'

import { schemaKey, fieldNameKey } from './symbols'

const schema = inject(schemaKey)
const fieldName = inject(fieldNameKey)
</script>

<template>
  <label :for="fieldName">
    <slot>
      <span v-text="schema && schema[fieldName].label"></span>
    </slot>
  </label>
</template>
